<script>
  import {onMount} from 'svelte';
  import {debounce, getChartSizes} from './settings';
  import BarsHorizontal from './BarsHorizontal.svelte';
  import BarsVertical from './BarsVertical.svelte';
  export let data = {};
  let width = 0;
  let tags = [];

  let chartProps = {
    height: 0,
    margins: {
      top: 0,
      right: 0,
      left: 0,
      bottom: 0,
    },
    orientation: null,
    width: 0,
  };

  const draw = () => {
    chartProps = getChartSizes(Math.max(data.meloni.length, data.schlein.length), width);
    tags = data.tags.map(d => (`<em>#${d}</em>`));
  };

  const debouncedSetWindowWidth = debounce(draw, 300);

  onMount(async () => {
    window.addEventListener('resize', debouncedSetWindowWidth);
    draw();
		return () => {
			window.removeEventListener('resize', debouncedSetWindowWidth);
		}
  });
</script>

<div class="card--single--wrapper" id="card--single--{data.id}">
  {#if data.title}
    <div class="card--single--header">
      <h4>{data.title}</h4>
      {#if data.description}
        <div class="card--single--description">{@html data.description}</div>
      {/if}
    </div>
  {/if}
  <div class="card--single--chart" bind:offsetWidth={width}>
    {#if chartProps.orientation === 'vertical'}
      <BarsVertical {chartProps} {data} />
    {/if}
    {#if chartProps.orientation === 'horizontal'}
      <BarsHorizontal {chartProps} {data} />
    {/if}
  </div>
  <div class="card--single--tags">Keywords: {@html tags.join(', ')}.</div>
</div>

<style>
  .card--single--chart {
    margin: 0;
    width: auto;
  }

  .card--single--tags {
    font-family: 'Fira Mono', monospace;
    font-size: 12px;
    font-weight: 500;
    padding: 0 10px;
    text-align: center;
    text-transform: uppercase;
  }

  @media screen and (min-width:1024px) {
    .card--single--chart {
      margin: 0 -20px;
    }
  }
</style>